module.exports = __webpack_public_path__ + "static/media/s_v9_t4.f3d98f96.mp3";